<div
  *ngIf="visible && (mobileVisibility === BillingVisibility.FULL || mobileVisibility === BillingVisibility.LINKS_ONLY_ON_MOBILE)"
  [ngClass]="classes" class="alert-absolute background-background"
>
  <ngb-alert [dismissible]="false" class="text-center w-100 m-0">
    {{ featureName }} not available on the {{ plansAlertData?.notAvailableForPlan }}.

    <ng-container *ngIf="mobileVisibility === BillingVisibility.FULL || mobileVisibility === BillingVisibility.LINKS_ONLY_ON_MOBILE">
      <a routerLink="/settings/location/billing" class="alert-link" [innerText]="plansAlertData?.linkText"></a>
      {{ plansAlertData?.afterLinkText }}
    </ng-container>
  </ngb-alert>
</div>
